import { SHOW_COLLECTIONS_FOR_ALL } from 'src/config/config'

import styles from './HomeBuyVendorBadge.module.scss'

const HomeBuyVendorBadge = () => {
  return (
    <div
      className={`${styles.homeBuyVendorBadge} ${SHOW_COLLECTIONS_FOR_ALL == 'true' ? '!bg-[#29EF97] !w-[48px]' : ''}`}
    />
  )
}

export default HomeBuyVendorBadge
